import React from 'react';
import logo from 'media/images/logos/logo.svg';
import Container from 'js/components/container/container';
import Row from 'js/components/grid/row';
import Col from 'js/components/grid/column';
import NeedHelpModal from './need-help-modal/need-help-modal';
import styles from '../quick-start.module.scss';

const PageHeader = ({ onGetHelp }) => (
    <div className={styles['header-bar']}>
        <Container size="medium">
            <Row justifyContent="space-between" alignItems="center">
                <Col spanXs={12} spanSm="auto">
                    <Row alignItems="center">
                        <Col span="auto">
                            <img
                                className={styles.logo}
                                src={logo}
                                alt="4D logo"
                            />
                        </Col>
                        <div className={styles['hide-on-mobile']}>
                            <Col span="auto">Contextual Targeting with 4D</Col>
                        </div>
                    </Row>
                </Col>
                <Col span="auto">
                    <NeedHelpModal onFinish={onGetHelp} />
                </Col>
            </Row>
        </Container>
    </div>
);

export default PageHeader;
